import { apiClient } from '../../../app/api/apiClient';
import type { CustomerDTO } from './customers.api';


interface CustomerResponse {
  customer: CustomerDTO;
}


export async function fetchCustomer(
  id: string,
): Promise<CustomerResponse> {

  const response = await apiClient.get<CustomerResponse>(
    `/api/customers/${id}`,
  );

  return response.data;
}
